import { Stack, Typography } from '@mui/material';
import Button from '~/components/common/Button';
import themes from '~/themes';
import CloseIcon from '~/assets/images/icons/close-white.svg';

type Props = {
  onCancel: () => void;
  loading?: boolean;
  onSave: () => void;
  disabled?: boolean;
};

const ActionBar = ({
  onCancel,
  loading = false,
  onSave,
  disabled = false,
}: Props) => (
  <Stack
    sx={{
      position: 'sticky',
      bottom: 0,
      maxWidth: '860px',
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      borderRadius: '2px',
      backgroundColor: themes.color.violet700,
      padding: 1.5,
      zIndex: 10,
      [themes.breakpoints.down('sm')]: {
        padding: 0.8,
      },
    }}
  >
    <Stack
      flexDirection='row'
      alignItems='center'
      gap={0.5}
      px={1.6}
      sx={{
        color: 'white',
        fontWeight: 500,
        cursor: 'pointer',
        [themes.breakpoints.down('md')]: {
          px: 0.8,
        },
      }}
      onClick={onCancel}
    >
      <img
        src={CloseIcon}
        alt=''
        style={{
          width: 9,
          height: 9,
        }}
      />
      Discard
    </Stack>
    <Stack
      flexDirection='row'
      alignItems='center'
      gap={0.8}
      pl={1.6}
      sx={{
        color: 'white',
        fontWeight: 500,
        cursor: 'pointer',
        [themes.breakpoints.down('sm')]: {
          paddingLeft: 0.8,
        },
      }}
    >
      <Button
        noRounder
        buttonType='text'
        onClick={onSave}
        sx={{
          [themes.breakpoints.down('md')]: {
            minWidth: 'unset !important',
            padding: '4px 8px',
          },
          '&:disabled': {
            opacity: 0.6,
          },
          'minWidth': '76px !important',
          'backgroundColor': 'white !important',
          'color': `${themes.color.violet700} !important`,
          'padding': '4px 16px',
          'borderRadius': '8px !important',
        }}
        loading={loading}
        disabled={disabled}
      >
        <Typography
          sx={{
            fontWeight: 500,
          }}
        >
          Save Changes
        </Typography>
      </Button>
    </Stack>
  </Stack>
);

export default ActionBar;
